import {
  SALES_BOOK_LOADING,
  GET_SALES_BOOK,
  GET_SALES_BOOK_SUCCESS,
  GET_SALES_BOOK_FAIL,
  ADD_SALES_BOOK_SUCCESS,
  ADD_SALES_BOOK_FAIL,
  DELETE_SALES_BOOK_SUCCESS,
  DELETE_SALES_BOOK_FAIL,
  UPDATE_SALES_BOOK_SUCCESS,
  UPDATE_SALES_BOOK_FAIL,
  SALES_BOOK_RESET
} from "./actionType";

const INIT_STATE = {
  salesBooks: [],
  error: {},
};

const SalesBook = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SALES_BOOK_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SALES_BOOK:
          return {
            ...state,
            salesBooks: action.payload.data,
            isSalesBookCreated: false,
            isSalesBookSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SALES_BOOK_FAIL:
      switch (action.payload.actionType) {
        case GET_SALES_BOOK_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSalesBookCreated: false,
            isSalesBookSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SALES_BOOK: {
      return {
        ...state,
        isSalesBookCreated: false,
        loading: true,
      };
    }

    case SALES_BOOK_LOADING: {
      return {
        ...state,
        isSalesBookCreated: false,
        loading: true,
      };
    }

    case ADD_SALES_BOOK_SUCCESS:
      return {
        ...state,
        isSalesBookCreated: true,
        loading: false,
        salesBooks: [action.payload.data, ...state.salesBooks],
      };

    case ADD_SALES_BOOK_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SALES_BOOK_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesBookCreated: true,
        salesBooks: state.salesBooks.filter(
          salesBooks => salesBooks.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SALES_BOOK_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SALES_BOOK_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesBookCreated: true,
        salesBooks: state.salesBooks.map(salesBooks =>
          salesBooks.id.toString() === action.payload.data.id.toString() ? { ...salesBooks, ...action.payload.data } : salesBooks
        ),
      };

    case UPDATE_SALES_BOOK_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SALES_BOOK_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default SalesBook;